<div class="form-group">
    <label *ngIf="label">{{label}}</label>
    <input [id]="idForm" [name]="idForm" [formControl]="control" class="form-control" #input
        [autocomplete]="autocomplete ? 'on' : 'off'" [ngClass]="size == '' ? '' : 'form-control-'+ size"
        [typeahead]="obj" [typeaheadOptionsLimit]="500" [typeaheadMinLength]="0" [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="optLimit" typeaheadOptionField="descripcion" [placeholder]="placeholder"
        [typeaheadSingleWords]="true" [typeaheadGroupField]="optGroup" (typeaheadOnSelect)="onSelect($event)" (typeaheadOnBlur)="onBlur($event, input)">
</div>